"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.transformCart = exports.totalFromList = exports.transformCartSimple = void 0;

var _lang = require("lodash/lang");

var _string = require("lodash/string");

var _product = require("@modules/product");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getDiscounts = function getDiscounts(discountList) {
  return discountList.filter(function (discount) {
    return discount.value >= 0;
  });
};

var getSurcharges = function getSurcharges(discountList) {
  return discountList.filter(function (discount) {
    return discount.value < 0;
  });
};

var transformCartSimple = function transformCartSimple(_ref) {
  var id = _ref.id,
      attributes = _ref.attributes;
  return {
    id: id,
    itemList: (0, _lang.isArray)(attributes.ids) ? {} : attributes.ids,
    numItems: attributes.number_products,
    postalcode: attributes.postalcode,
    total: Number.parseFloat(attributes.total).toLocaleString('es-ES', {
      style: 'currency',
      currency: 'EUR'
    })
  };
};
/** @TODO remove when the API will return the real value */


exports.transformCartSimple = transformCartSimple;

var totalFromList = function totalFromList(list) {
  if (!list) return 0 + '';
  return list.reduce(function (accumulator, item) {
    return accumulator + item.value;
  }, 0) * -1 + '';
};

exports.totalFromList = totalFromList;

var transformCart = function transformCart(_ref2) {
  var id = _ref2.id,
      attributes = _ref2.attributes;
  return _objectSpread({}, transformCartSimple({
    id: id,
    attributes: attributes
  }), {
    delivery: {
      addressID: attributes.delivery_address_id,
      date: attributes.delivery_date,
      end: attributes.delivery_end,
      invoiceAddressID: attributes.invoice_address_id,
      slotID: attributes.slot_id,
      start: attributes.delivery_start,
      comments: (0, _string.trim)(attributes.comments)
    },
    order: {
      discounts: getDiscounts(attributes.discounts),
      surcharges: getSurcharges(attributes.discounts),
      totalDiscounts: Number.parseFloat(totalFromList(getDiscounts(attributes.discounts))).toLocaleString('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }),
      totalDonation: Number.parseFloat(attributes.total_donation).toLocaleString('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }),
      totalProducts: Number.parseFloat(attributes.total_products).toLocaleString('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }),
      totalShipping: Number.parseFloat(attributes.total_shipping).toLocaleString('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }),
      totalSurcharges: totalFromList(getSurcharges(attributes.discounts))
    },
    products: attributes.products.map(function (product) {
      return (0, _product.productMutator)(product);
    })
  });
};

exports.transformCart = transformCart;
var _default = {};
exports.default = _default;